import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

import { AppDataService } from '../../core/services/app-data.service';
import { ReportService } from '../../core/services/report.service';
import { ExportService } from '../../core/services/export.service';
import { formatCurrency, stockLevelClass } from '../../core/utils/format.util';
import { matchesItemQuery } from '../../core/utils/item-filter.util';
import { environment } from '../../environments/environment';
import { ReportDateRangeComponent } from '../report-date-range/report-date-range.component';
import { ReportDateRangeService } from '../../report-date-range.service';

@Component({
  selector: 'app-low-stock-report',
  standalone: true,
  imports: [FormsModule, RouterLink, ReportDateRangeComponent],
  templateUrl: './low-stock.component.html',
  styleUrl: '../../report-shared.css',
})
export class LowStockReportComponent implements OnInit {
  private readonly appData = inject(AppDataService);
  private readonly reports = inject(ReportService);
  private readonly exporter = inject(ExportService);
  protected readonly dateRange = inject(ReportDateRangeService);
  protected readonly stockLevelClass = stockLevelClass;

  private readonly range = computed(() => ({
    startDate: this.dateRange.appliedStartDate(),
    endDate: this.dateRange.appliedEndDate(),
  }));

  protected readonly itemNameFilter = signal('');

  protected readonly items = computed(() =>
    this.reports
      .getLowStockReport(this.range())
      .filter((row) =>
        matchesItemQuery(this.itemNameFilter(), row.name, row.code),
      ),
  );

  ngOnInit(): void {
    if (!environment.useMockData) {
      this.appData.refreshAll();
    }
  }

  exportData(): void {
    this.exporter.downloadCsv(
      `low-stock-${new Date().toISOString().slice(0, 10)}`,
      this.items().map((row) => ({ ...row })),
    );
  }
}
